import { Link } from 'react-router-dom';
import { ROUTES, SECTION } from '../routes.js';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner container">
        <div className="footer__brand">
          <Link to={ROUTES.home} className="footer__logo" aria-label="Off Market – Startseite">
            <img
              src={`${process.env.PUBLIC_URL}/off_market.png`}
              alt="Off Market"
              className="footer__logo-img"
            />
          </Link>
          <p className="footer__tagline">
            Pre Market Scouting für Käufer, die nicht warten, bis ein Exposé
            online geht.
          </p>
        </div>

        <nav className="footer__cols" aria-label="Footer-Navigation">
          <div className="footer__col">
            <h4>Navigation</h4>
            <Link to={`${ROUTES.home}#${SECTION.prozess}`}>Ablauf</Link>
            <Link to={`${ROUTES.home}#${SECTION.kontakt}`}>Kontakt</Link>
          </div>
          <div className="footer__col">
            <h4>Kontakt</h4>
            <Link to={`${ROUTES.home}#${SECTION.kontakt}`}>Anfrage stellen</Link>
            <Link to={`${ROUTES.home}#${SECTION.kontakt}`}>Kostenloses Kennenlernen</Link>
          </div>
          <div className="footer__col">
            <h4>Rechtliches</h4>
            <Link to={ROUTES.impressum}>Impressum</Link>
            <Link to={ROUTES.datenschutz}>Datenschutz</Link>
          </div>
        </nav>
      </div>

      <div className="footer__base container">
        <span>© {year} ProWick Properties. Alle Rechte vorbehalten.</span>
        <span className="footer__base-right">
          Made with care in Österreich
        </span>
      </div>
    </footer>
  );
}
